import React, { useState, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";

const documentos = [
  {
    id: 1,
    titulo: "Estatuto Social COOPERFORTE",
    descricao: "Documento que define as bases legais e estruturais da Cooperforte.",
    url: "https://www.cf.coop.br/wp-content/uploads/2022/09/ESTATUTOSOCIALCOOPERFORTE.pdf"
  },
  {
    id: 2,
    titulo: "Código de Ética COOPERFORTE",
    descricao: "Regras de conduta e responsabilidade ética da cooperativa.",
    url: "https://www.cf.coop.br/wp-content/uploads/2023/01/codigo-de-etica.pdf"
  },
  {
    id: 3,
    titulo: "Programa de Integridade",
    descricao: "Compromisso com a transparência, integridade e governança.",
    url: "https://www.cf.coop.br/wp-content/uploads/2025/03/Programa-de-integridade-V3_2025-2.pdf"
  },
  {
    id: 4,
    titulo: "Regulamento da Eleição",
    descricao: "Normas para o processo eleitoral de Delegados Seccionais.",
    url: "https://www.cf.coop.br/wp-content/uploads/2025/08/Regulamento-de-Eleicao-de-Delegados-Seccionais-2025.pdf"
  },
  {
    id: 5,
    titulo: "Edital da Eleição",
    descricao: "Convocação oficial para o processo de eleição 2025.",
    url: "https://www.cf.coop.br/wp-content/uploads/2025/08/Edital-de-Convocacao-Eleicao-Delegados-Seccionais-2025-Edital-13.08.2025-v.12.08.2025-as-19h.pdf"
  }
];

const SecaoDocumentos = () => {
  const [docSelecionado, setDocSelecionado] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);

  const abrirDocumento = (doc, index) => {
    window.open(doc.url, "_blank");
        /*
    
     const isMobile = window.innerWidth < 768;
     if (isMobile) {
        window.open(doc.url, "_blank");

  } else {
     setCurrentIndex(index);
     setDocSelecionado(doc);
   }*/
  };

  const scrollCarousel = (direction) => {
    const scrollAmount = 300;
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth"
      });
    }
  };

  return (
    <section className=" py-10 px-4">
      <div className="mx-auto text-center">
        {/* Título */}
        <h2 className="text-xl sm:text-xl font-bold mb-2"> Documentos Importantes
        </h2>
        {/* Linha amarela */}
        <div className="w-24 h-1 bg-[#f6b100] mx-auto mb-6" />
      </div>

      {/* Carousel wrapper */}
      <div className="relative sm:static">
        {/* Setas de navegação */}
        <div className="flex justify-between sm:hidden mb-2">
          <button
            onClick={() => scrollCarousel("left")}
            className="text-xl bg-yellow-400 px-3 py-1 rounded shadow"
            aria-label="Voltar documentos"
          >
            ‹
          </button>
          <button
            onClick={() => scrollCarousel("right")}
            className="text-xl bg-yellow-400 px-3 py-1 rounded shadow"
            aria-label="Avançar documentos"
          >
            ›
          </button>
        </div>

        {/* Lista de documentos */}
        <div
          ref={carouselRef}
          className="flex gap-4 overflow-x-auto pb-4 sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 sm:overflow-visible sm:pb-0"
        >
          {documentos.map((doc, index) => (
            <div
              key={doc.id}
              onClick={() => abrirDocumento(doc, index)}
              className="cursor-pointer flex flex-col items-center gap-3 shrink-0 w-[180px] sm:w-auto"
              aria-label={`Abrir documento: ${doc.titulo}`}
            >
              {/* Ícone */}
              <img
                src="https://cf.coop.br/votacao-site/build/images/folder.png"
                alt="Documento"
                className="w-[150px] h-[150px]"
              />

              {/* Título estilo botão */}
              <div className="bg-yellow-400 text-black text-sm font-semibold px-3 py-1 rounded hover:bg-yellow-500 transition">
                {doc.titulo.replace(" COOPERFORTE", "").replace(" da Eleição", "")}
              </div>
            </div>
          ))}
        </div>

        {/* Bolinhas indicador */}
        <div className="flex justify-center gap-2 mt-4 sm:hidden">
          {documentos.map((_, i) => (
            <span
              key={i}
              className={`h-2 w-2 rounded-full transition ${i === currentIndex ? "bg-yellow-600" : "bg-gray-300"
                }`}
            ></span>
          ))}
        </div>
      </div>

      {/* Modal com animação */}
      <Transition show={!!docSelecionado} as={React.Fragment}>
        <Dialog
          as="div"
          open={!!docSelecionado}
          onClose={() => setDocSelecionado(null)}
          className="relative z-50"
        >
          <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
          <div className="fixed inset-0 flex items-center justify-center p-4">
            <Transition.Child
              enter="transition-opacity ease-out duration-300 transform"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="transition-opacity ease-in duration-200 transform"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="bg-white max-w-5xl w-full h-[90vh] p-4 rounded shadow relative">
                <Dialog.Title className="text-lg font-semibold text-gray-900 mb-2">
                  {docSelecionado?.titulo}
                </Dialog.Title>
                <button
                  onClick={() => setDocSelecionado(null)}
                  className="absolute top-3 right-4 text-sm text-red-600"
                  aria-label="Fechar documento"
                >
                  Fechar ✕
                </button>
                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm text-gray-500">Leitura online</span>
                  <a
                    href={docSelecionado?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-blue-600 hover:underline"
                    aria-label="Baixar documento em PDF"
                  >
                    Baixar PDF ↧
                  </a>
                </div>
                <iframe
                  src={docSelecionado?.url}
                  title={docSelecionado?.titulo}
                  className="w-full h-[90%] border"
                ></iframe>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </section>
  );
};

export default SecaoDocumentos;
